module.exports = __webpack_public_path__ + "/hashedassets-launcher/v2/reload.7af8f54e6362371552c63c167d65c5d3.svg";